export const ELocalStorageType = {
  EXPERIMENTS: "experiments",
};
